<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;</button>
    <b-link class="navbar-brand" to="#"></b-link>
    <button class="navbar-toggler sidebar-toggler d-md-down-none mr-auto" type="button" @click="sidebarMinimize">&#9776;</button>
    <div class="btn-group pull-right" role="group" style="margin-right: 10px;">
      <button id="btnGroupDrop1" type="button" class="btn dropdown-toggle" 
          style="background: transparent" data-toggle="dropdown" 
          aria-haspopup="true" aria-expanded="false">
        <i class="fa fa-person"></i>&nbsp;{{account.fullname}}
      </button>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="btnGroupDrop1" style="right: 0px; left: auto">
        <router-link to="/profile/password" class="dropdown-item">Change Password</router-link>
        <button class="dropdown-item" @click="logout">Log Out</button>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  data () {
    return {
      account: JSON.parse(localStorage.getItem('account'))
    }
  },
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    logout () {
      localStorage.clear()
      this.$router.push('/login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue